import React from "react";
import PropTypes from "prop-types";
SubgroupWrapper.propTypes = {
  children: PropTypes.node.isRequired,
  colSpan: PropTypes.number.isRequired,
  label: PropTypes.string.isRequired
}; // Note: this is shared between <Edit> and <Preview> for displaying list(s) of inputs

export default function SubgroupWrapper(_ref) {
  var children = _ref.children,
      colSpan = _ref.colSpan,
      label = _ref.label;
  // We set a short var name for a unique ID we'll use for styling
  var id = "pac-subgroupd-wrapper";
  return /*#__PURE__*/React.createElement("tr", {
    id: id
  }, /*#__PURE__*/React.createElement("style", {
    dangerouslySetInnerHTML: {
      __html: "\n            #" + id + " > td {\n              padding: 0;\n            }\n            #" + id + " > td > strong {\n              padding: 8px;\n              display: block;\n              text-transform: uppercase;\n            }\n            #" + id + " > td > table {\n              margin: 0;\n            }\n            #" + id + " > td > table > tbody > tr:first-child > td, " + id + " > td > table > tbody > tr:first-child > td > button {\n              border-top: 0;\n            }\n            #" + id + " > td > table > tbody > tr > td:first-child {\n              border-top: 0;\n              text-indent: 8px;\n            }\n          "
    }
  }), /*#__PURE__*/React.createElement("td", {
    className: "col-xs-12",
    colSpan: colSpan
  }, label && /*#__PURE__*/React.createElement("strong", null, label), /*#__PURE__*/React.createElement("table", {
    className: "table"
  }, /*#__PURE__*/React.createElement("tbody", null, children))));
}